var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.showMap)?_c('Indexadd',{on:{"xgMap":_vm.hideMap}}):_vm._e(),(_vm.showMap)?_c('mapSearch',{attrs:{"typeId":_vm.typeId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }